// image-shrink.js — ONE way the browser turns a dropped or pasted picture into
// something small enough to send. Two callers: the chat's pasted pictures
// (ChatView, 1568 px, what the model reads) and a dropped project logo
// (PictureDrop, a thumbnail). Same redraw either way, so it lives once.
//
// readAsDataUrl(blob) → 'data:<type>;base64,…'
// shrinkImage(file, { maxEdge, keepBytes, quality }) → { media_type, data } (base64)
//   Kept as it is when it is already small enough and a browser type; otherwise
//   redrawn at maxEdge as JPEG, white behind any transparency.

export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

export const readAsDataUrl = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = () => reject(r.error);
  r.readAsDataURL(blob);
});

export async function shrinkImage(file, { maxEdge, keepBytes, quality = 0.9 }) {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
  let url;
  if (scale === 1 && file.size <= keepBytes && IMAGE_TYPES.includes(file.type)) {
    url = await readAsDataUrl(file);
  } else {
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    url = canvas.toDataURL('image/jpeg', quality);
  }
  bitmap.close?.();
  const [head, data] = url.split(',');
  return { media_type: head.slice(5, head.indexOf(';')), data };
}
